'use client'

import { FaLink } from 'react-icons/fa6'
import { toast } from 'react-toastify'
import { getI18n, I18nDictionary, LangCode } from '../i18n/lang-context'
import { getGlossaryLink } from './glossary-link'
import { MouseEvent } from 'react'

const I18N: I18nDictionary = {
  titleMessage: {
    en: 'Copy direct link to clipboard',
    fr: 'Copier le lien direct dans le presse-papier'
  },
  successMessage: {
    en: 'Direct link copied to clipboard',
    fr: 'Lien direct copié dans le presse-papier'
  }
}

export default function GlossaryCopyLink({ _key, langCode }: { _key: string, langCode: LangCode }) {

  const i18n = getI18n(I18N, langCode)

  const copyLink = (event: MouseEvent, key: string) => {
    event.stopPropagation()
    event.preventDefault()
    navigator.clipboard.writeText(key)
    toast.success(i18n.successMessage)
  }

  return <FaLink title={i18n.titleMessage} size={14}
    className='cursor-pointer text-primary opacity-80 hover:opacity-100 dark:text-primaryBright'
    onClick={(event) => copyLink(event, getGlossaryLink(_key, langCode))} />
}
